import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    height: '100%',
    width: '100%',
    position: 'relative',
  },
  isWhite: {
    backgroundColor: '#ffff',
  },
  img: {
    flex: 1,
  },
  iconContainer: {
    zIndex: 2,
    width: '30%',
    height: '30%',
    maxWidth: 100,
    maxHeight: 100,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 50,
    verticalAlign: 'auto', // center the child vertically
    textAlign: 'center', // center the child horizontally
  },
  greenBg: {
    backgroundColor: '#50BF92',
  },
  redBg: {
    backgroundColor: 'crimson',
  },
  layout: {
    position: 'absolute',
    top: 0,
    right: 0,
    height: '100%',
    width: '100%',
    zIndex: 1,
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-start',
    padding: 10,
  },
  greyBackground: {
    backgroundColor: 'rgba(0,0,0, 0.5)',
  },
});
